
import { useContext, useMemo, useState, useEffect, useRef } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./GasSweetening.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import { simulateCooler } from "../processEngines/CoolerEngine";
import SingleStageCompressorFaceplate from "../components/SingleStageCompressor/SingleStageCompressorFaceplate";
import {simulateSingleStageCompressor, startCompressor, stopCompressor, updateCompressor, createCompressorState} from "../components/SingleStageCompressor/SingleStageCompressorEngine";
import CompressorTrendFaceplate from "../components/SingleStageCompressor/CompressorTrendFaceplate";
import { CompressorContext } from "../context/CompressorContext";

import { trackPageVisit } from "../competency/PageTracker";





 
      /*  CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function GasSweetening() {

        useEffect(() => {
  
    trackPageVisit("GasSweetening");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);
    const [showTrend, setShowTrend] = useState(false);
    
    
    
const { compressorE, CompressorTrendFaceplate } = useContext(CompressorContext);

const compressor = compressorE; // or A depending on page
    

    const [open, setOpen] = useState(false);
    // ======================================
    // FORCE UI REFRESH FOR COMPRESSOR STATE
    // ======================================

    const [, forceRender] = useState(0);

    useEffect(() => {

      const interval = setInterval(() => {

        forceRender(v => v + 1);

      }, 100);

      return () => clearInterval(interval);

    }, []);

    

    

  const DEFAULT_VALVES = {
  FCV_2101: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2102: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2103: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2104: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("GasSweetening_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2101: { ...DEFAULT_VALVES.FCV_2101, ...parsed.FCV_2101 },
      FCV_2102: { ...DEFAULT_VALVES.FCV_2102, ...parsed.FCV_2102 },
      FCV_2103: { ...DEFAULT_VALVES.FCV_2103, ...parsed.FCV_2103 },
      FCV_2104: { ...DEFAULT_VALVES.FCV_2104, ...parsed.FCV_2104 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("GasSweetening_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES GOING TO LP COMPRESSOR =================

  const [AIT_2901, setAIT_2901] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("AIT_2901")) || 0;
            setAIT_2901(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_2205, setPT_2205] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2205")) || 0;
            setPT_2205(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_2205, setTT_2205] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_2205")) || 0;
            setTT_2205(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_2205, setFIC_2205] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2205")) || 0;
            setFIC_2205(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);



  /* ================= VALVE STATUS ================= */

  const isXV2101Open = valves?.XV_2101 === false;
  const isXV2102Open = valves?.XV_2102 === false;
  const isXV2103Open = valves?.XV_2103 === false;
  const isXV2104Open = valves?.XV_2104 === false;
  const isXV2105Open = valves?.XV_2105 === false;




  const FIC_2101 = isXV2102Open ? FIC_2205 * (valveData?.FCV_2104?.opening || 0)/100 : 0;
  const TT_2101 = isXV2102Open ? TT_2205 * (valveData?.FCV_2104?.opening || 0)/100 : 0;
  const PT_2101 = isXV2102Open ? PT_2205 * (valveData?.FCV_2104?.opening || 0)/100 : 0;
  const PT_21011 = PT_2205 - PT_2101;

  const H2S_2101 = isXV2102Open ?  AIT_2901 : 0.01123;

  const FIC_2102 = FIC_2205 - FIC_2101;

  const FIC_2107 = isXV2105Open ? 50.234 : 0;

  const PT_2107 = isXV2105Open ? 0.8 : 0.03;

  const PT_2105 = 0.234;



// ======================================================
// P-2101 PUMP LOGIC
// ======================================================

// ======================================================
// PUMP STATUS
// ======================================================

const pumpRunning =
  (pumpData?.["P-2101"]?.running ?? false) &&
  PT_2105 > 0.05;

// ======================================================
// CONSTANT SUCTION FLOW
// ======================================================

const pumpSuctionFlow = 16.453;

// ======================================================
// OUTPUT VARIABLES
// ======================================================

let FIC_2105 = 0; // FLOW TO H2S SCAVENGER

let PT_2103 = 0; // PRESSURE TO H2S SCAVENGER

let FIC_2108 = 0; // FLOW TO VACUUM DEAERATOR

let PT_2108 = 0; // PRESSURE TO VACUUM DEAERATOR

// ======================================================
// PUMP NOT RUNNING
// ======================================================

if (!pumpRunning) {

  FIC_2105 = 0;
  PT_2103 = 0;

  FIC_2108 = 0;
  PT_2108 = 0;
}

// ======================================================
// PUMP RUNNING
// ======================================================

else {

  // ======================================================
  // PUMP DISCHARGE PRESSURE
  // ======================================================

  const pumpDischargePressure =
    PT_2105 + 0.85;

  // ======================================================
  // CONTROL VALVE OPENINGS
  // ======================================================

  const FCV_2101_OPENING =
    (valveData?.FCV_2101?.opening || 0) / 100;

  const FCV_2102_OPENING =
    (valveData?.FCV_2102?.opening || 0) / 100;

  // ======================================================
  // TOTAL OPENING
  // ======================================================

  const totalOpening =
    FCV_2101_OPENING +
    FCV_2102_OPENING;

  // ======================================================
  // AVOID DIVISION BY ZERO
  // ======================================================

  if (totalOpening <= 0) {

    FIC_2105 = 0;
    PT_2103 = pumpDischargePressure;

    FIC_2108 = 0;
    PT_2108 = pumpDischargePressure;
  }

  // ======================================================
  // FLOW SPLITTING
  // ======================================================

  else {

    // ====================================================
    // FLOW DISTRIBUTION
    // ====================================================

    FIC_2105 =
      pumpSuctionFlow *
      (FCV_2101_OPENING / totalOpening);

    FIC_2108 =
      pumpSuctionFlow *
      (FCV_2102_OPENING / totalOpening);

    // ====================================================
    // PRESSURE DISTRIBUTION
    // ====================================================

    PT_2103 =
      pumpDischargePressure *
      (0.55 + (FCV_2101_OPENING * 0.45));

    PT_2108 =
      pumpDischargePressure *
      (0.55 + (FCV_2102_OPENING * 0.45));

    // ====================================================
    // SMALL PIPELINE LOSSES
    // ====================================================

    FIC_2105 *= 0.995;

    FIC_2108 *= 0.995;
  }
}

// ======================================================
// OPTIONAL LOCAL STORAGE
// ======================================================

localStorage.setItem("FIC_2105", FIC_2105);

localStorage.setItem("PT_2103", PT_2103);

localStorage.setItem("FIC_2108", FIC_2108);

localStorage.setItem("PT_2108", PT_2108);







// ======================================================
// H2S SCAVENGER VESSEL
// ======================================================

// ======================================================
// OUTPUT VARIABLES
// ======================================================

// GAS OUTLET

let FIC_21021 = 0;

let PT_2102 = 0;

let TT_2102 = 0;

let H2S_2102 = 0;

// LIQUID OUTLET

let FIC_2106 = 0;

let PT_2106 = 0;

let TT_2106 = 0;

// ======================================================
// GAS FLOW AVAILABLE ?
// ======================================================

const gasAvailable =
  FIC_2101 > 0 &&
  PT_2101 > 0.05;

// ======================================================
// NO GAS FLOW
// ======================================================

if (!gasAvailable) {

  FIC_21021 = 0;

  PT_2102 = 0;

  TT_2102 = 25;

  H2S_2102 = 0;

  PT_2106 = 0;

  TT_2106 = 25;
}

// ======================================================
// GAS FLOW PRESENT
// ======================================================

else {

  // ====================================================
// H2S REMOVAL BASED ON SCAVENGER FLOW
// ====================================================

/*
  FIC_2105 range:
  0  → no scavenger
  17 → maximum scavenger injection
*/

const scavengerFlowRatio =
  Math.min(FIC_2105 / 17, 1);

// ====================================================
// DYNAMIC SCAVENGER EFFICIENCY
// ====================================================

/*
  Higher chemical flow
  =
  stronger H2S removal
*/

let scavengerEfficiency =
  0.05 + (scavengerFlowRatio * 0.90);

/*
  Range:
  5%  minimum removal
  95% maximum removal
*/

// ====================================================
// H2S REDUCTION
// ====================================================

H2S_2102 =
  H2S_2101 *
  (1 - scavengerEfficiency);

// ====================================================
// REALISTIC OPERATING LIMITS
// ====================================================

// MAXIMUM CHEMICAL RATE
if (FIC_2105 >= 15) {

  H2S_2102 =
    Math.max(
      2,
      H2S_2102 * 0.35
    );
}

// MEDIUM CHEMICAL RATE
else if (FIC_2105 >= 8) {

  H2S_2102 =
    Math.max(
      5,
      H2S_2102 * 0.020
    );
}

// LOW CHEMICAL RATE
else if (FIC_2105 >= 3) {

  H2S_2102 =
    Math.max(
      10,
      H2S_2102 * 0.065
    );
}

// VERY LOW / NO CHEMICAL
else {

  H2S_2102 =
    H2S_2101 * 0.8987;
}

// ====================================================
// FINAL SAFETY LIMITS
// ====================================================

if (H2S_2102 < 2)
  H2S_2102 = 2;

if (H2S_2102 > H2S_2101)
  H2S_2102 = H2S_2101;

  // ====================================================
  // GAS FLOW LOSSES
  // ====================================================

  FIC_21021 =
    FIC_2101 * 0.992;

  // ====================================================
  // PRESSURE DROP
  // ====================================================

  PT_2102 =
    PT_2101 * 0.96;

  // ====================================================
  // TEMPERATURE CHANGE
  // ====================================================

  /*
    Slight exothermic reaction
  */

  TT_2102 =
    TT_2101 + 3;

  // ====================================================
  // LIQUID BOTTOMS SECTION
  // ====================================================

  if (isXV2104Open) {

    // ================================================
    // CONTROL VALVE OPENING
    // ================================================

    const FCV_2103_OPENING =
      (valveData?.FCV_2103?.opening || 0) / 100;

    // ================================================
    // LIQUID FLOW
    // ================================================

    FIC_2106 =
       FCV_2103_OPENING *
      29.38;

    // ================================================
    // LIQUID PRESSURE
    // ================================================

    PT_2106 =
      PT_2103 *
      (0.55 + (FCV_2103_OPENING * 0.45));

    // ================================================
    // LIQUID TEMPERATURE
    // ================================================

    TT_2106 =
      TT_2102 - 5;
  }

  // ====================================================
  // BOTTOM VALVE CLOSED
  // ====================================================

  else {

    FIC_2106 = 0;

    PT_2106 =
      PT_2103;

    TT_2106 =
      TT_2102;
  }
}

// ======================================================
// OPTIONAL LOCAL STORAGE
// ======================================================

localStorage.setItem("FIC_2102", FIC_2102);

localStorage.setItem("PT_2102", PT_2102);

localStorage.setItem("TT_2102", TT_2102);

localStorage.setItem("H2S_2102", H2S_2102);

localStorage.setItem("FIC_2106", FIC_2106);

localStorage.setItem("PT_2106", PT_2106);

localStorage.setItem("TT_2106", TT_2106);

const LG_RATIO = FIC_2105/FIC_2101;

const PDT_2101 = PT_2101 - PT_2102;

const FIC_2104 = FIC_2102 + FIC_21021;




 useEffect(() => {
  localStorage.setItem("FIC_2104", FIC_2104);
}, [FIC_2104]);

  useEffect(() => {
  localStorage.setItem("PT_2102", PT_2102);
}, [PT_2102]);

  useEffect(() => {
  localStorage.setItem("TT_2102", TT_2102);
}, [TT_2102]);

  useEffect(() => {
  localStorage.setItem("PT_21011", PT_21011);
}, [PT_21011]);
 


  return (
    <div className="GasSweetening-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "230px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 300px"
      }}>
       GAS SWEETENING UNIT
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2971 */}
      <Valve
        className="XV-2101"
        tag="XV_2101"
        x={455}
        y={92}
        isClosed={valves.XV_2101}
        toggle={toggleValve}
      />

      {/* XV-2102 */}
      <Valve
        className="XV-2102"
        tag="XV_2102"
        x={268}
        y={156}
        isClosed={valves.XV_2102}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-2103 */}
      <Valve
        className="XV-2103"
        tag="XV_2103"
        x={510}
        y={160}
        isClosed={valves.XV_2103}
        toggle={toggleValve}
      />

      {/* XV-2104 */}
      <Valve
        className="XV-2104"
        tag="XV_2104"
        x={576}
        y={493}
        isClosed={valves.XV_2104}
        toggle={toggleValve}
      />

      {/* XV-2105 */}
      <Valve
        className="XV-2105"
        tag="XV_2105"
        x={1132}
        y={650}
        isClosed={valves.XV_2105}
        toggle={toggleValve}
      />

      

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2101 */}
        <svg width="80" height="50" viewBox="0 0 210 220" className="FCV-2101"
          style={{ position: "absolute", left: 742, top: 594}}  onClick={() => openPanel("FCV_2101")}>
          
          <defs>
            <linearGradient id="metal_2101">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,210 100,150 20,110"
            fill="url(#metal_2101)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,210 100,150 180,110"
            fill="url(#metal_2101)" stroke="#7f8c8d" strokeWidth="2" />
          </svg>
        
         {/* FCV-2102 */}
        <svg width="80" height="50" viewBox="0 0 210 220" className="FCV-2102"
          style={{ position: "absolute", left: 630, top: 711}}  onClick={() => openPanel("FCV_2102")}>
          
          <defs>
            <linearGradient id="metal_2102">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,210 100,150 20,110"
            fill="url(#metal_2102)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,210 100,150 180,110"
            fill="url(#metal_2102)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* FCV-2103 */}
        <svg width="80" height="50" viewBox="0 0 210 220" className="FCV-2103"
          style={{ position: "absolute", left: 214, top: 644}}  onClick={() => openPanel("FCV_2103")}>
          
          <defs>
            <linearGradient id="metal_2103">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,210 100,150 20,110"
            fill="url(#metal_2103)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,210 100,150 180,110"
            fill="url(#metal_2103)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* FCV-2104 */}
        <svg width="80" height="50" viewBox="0 0 210 220" className="FCV-2104"
          style={{ position: "absolute", left: 276, top: 394}}  onClick={() => openPanel("FCV_2104")}>
          
          <defs>
            <linearGradient id="metal_2104">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,210 100,150 20,110"
            fill="url(#metal_2104)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,210 100,150 180,110"
            fill="url(#metal_2104)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2101?.opening || 0)}
        x={765}
        y={648}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2102?.opening || 0)}
        x={650}
        y={757}
      />
      <ValveOutput
        value={Number(valveData?.FCV_2103?.opening || 0)}
        x={237}
        y={691}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2104?.opening || 0)}
        x={300}
        y={451}
      />



          {/* ================= TRANSMITTERS OUTPUTS ================= */}

      
      <Transmitter
          tag="FIC-2101"
          value={[FIC_2101]}
          x={125}
          y={196}
          unit="SCF/S"
          max={200}
          HH={188}
          H={175}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF GAS FROM HP GAS COOLER TO H2S SCAVENGER VESSEL FOR TREATMENT"
        />
      <Transmitter
          tag="FIC-2102"
          value={[FIC_2102]}
          x={325}
          y={83}
          unit="SCF/S"
          max={200}
          HH={188}
          H={175}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF MAIN GAS LINE (UNTREATED) FROM HP GAS COOLER TO TEG CONTACTOR COOLER"
        />

        <Transmitter
          tag="TT-2101"
          value={TT_2101}
          x={125}
          y={226}
          unit="°C"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF GAS FROM HP GAS COOLER TO H2S SCAVENGER VESSEL FOR TREATMENT"
        />

        <Transmitter
          tag="PT-2101"
          value={PT_2101}
          x={125}
          y={255}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF GAS FROM HP GAS COOLER TO H2S SCAVENGER VESSEL FOR TREATMENT"
        />

        <Transmitter
          tag="PT-21011"
          value={PT_21011}
          x={325}
          y={63}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="TRANSPARENT"
          description="PRESSURE OF UNTREATED GAS FROM HP GAS COOLER THROUGH BYPASS OF H2S SCAVENGER VESSEL"
        />

        <Transmitter
          tag="H2S-2101"
          value={H2S_2101}
          x={125}
          y={283}
          unit="ppm"
          max={2}
          max={1000}
          HH={800}
          H={600}
          L={3}
          LL={1}
          c="lime"
          description="CONCENTRATION OF HYDROGEN SULFIDE IN GAS FROM HP GAS COOLER TO H2S SCAVENGER VESSEL FOR TREATMENT"
        />
        <Transmitter
          tag="H2S-2102"
          value={H2S_2102}
          x={895}
          y={153}
          unit="ppm"
          max={50}
          HH={40}
          H={30}
          L={3}
          LL={1}
          c="lime"
          description="CONCENTRATION OF HYDROGEN SULFIDE IN GAS AT DISCHARGE OF H2S SCAVENGER VESSEL FOR AFTER TREATMENT"
        />

        <Transmitter
          tag="FIC-2107"
          value={[FIC_2107]}
          x={1135}
          y={705}
          unit="LPM"
          max={200}
          HH={188}
          H={175}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF CHEMICAL SCAVENGER (TRIAZINE OR ALDEHYDE) FROM BOAT LANDING TO SCAVENGER STORAGE TANK"
        />

        <Transmitter
          tag="PT-2107"
          value={PT_2107}
          x={1035}
          y={705}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF CHEMICAL SCAVENGER (TRIAZINE OR ALDEHYDE) FROM BOAT LANDING TO SCAVENGER STORAGE TANK"
        />

        <Transmitter
          tag="PT-2105"
          value={PT_2105}
          x={975}
          y={403}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF CHEMICAL SCAVENGER STORAGE TANK"
        />

        <Transmitter
          tag="FIC-2105"
          value={[FIC_2105]}
          x={840}
          y={395}
          unit="LPM"
          max={200}
          HH={188}
          H={175}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF CHEMICAL SCAVENGER (TRIAZINE OR ALDEHYDE) FROM SCAVENGER STORAGE TANK TO H2S SCAVENGER SEPARATOR"
        />

        <Transmitter
          tag="PT-2103"
          value={PT_2103}
          x={650}
          y={260}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF CHEMICAL SCAVENGER (TRIAZINE OR ALDEHYDE) FROM SCAVENGER STORAGE TANK TO H2S SCAVENGER SEPARATOR"
        />

        <Transmitter
          tag="FIC-2108"
          value={[FIC_2108]}
          x={473}
          y={720}
          unit="LPM"
          max={200}
          HH={188}
          H={175}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF CHEMICAL SCAVENGER (TRIAZINE OR ALDEHYDE) FROM SCAVENGER STORAGE TANK TO VACUUM DEARATOR"
        />

        <Transmitter
          tag="PT-2108"
          value={PT_2108}
          x={380}
          y={720}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF CHEMICAL SCAVENGER (TRIAZINE OR ALDEHYDE) FROM SCAVENGER STORAGE TANK TO VACUUM DEARATOR"
        />

        <Transmitter
          tag="FIC-21021"
          value={[FIC_21021]}
          x={895}
          y={243}
          unit="SCF/S"
          max={200}
          HH={188}
          H={175}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF GAS AT DISCHARGE OF H2S SCAVENGER VESSEL FOR AFTER TREATMENT"
        />

        <Transmitter
          tag="PT-2102"
          value={PT_2102}
          x={895}
          y={183}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF GAS AT DISCHARGE OF H2S SCAVENGER VESSEL FOR AFTER TREATMENT"
        />

        <Transmitter
          tag="TT-2102"
          value={TT_2102}
          x={895}
          y={213}
          unit="°C"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF GAS AT DISCHARGE OF H2S SCAVENGER VESSEL FOR AFTER TREATMENT"
        />

        <Transmitter
          tag="LG_RATIO"
          value={LG_RATIO}
          x={895}
          y={273}
          unit=""
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="RATIO OF CHEMICAL SCAVENGER LIQUID PER GAS TREATED"
        />

        <Transmitter
          tag="FIC-2106"
          value={[FIC_2106]}
          x={415}
          y={653}
          unit="LPM"
          max={40}
          HH={38}
          H={25}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF FLUID FROM BOTTOM OF H2S SCAVENGER VESSEL TO DE-OILER VESSEL"
        />

        <Transmitter
          tag="PT-2106"
          value={PT_2106}
          x={415}
          y={592}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF FLUID FROM BOTTOM OF H2S SCAVENGER VESSEL TO DE-OILER VESSEL"
        />

        <Transmitter
          tag="TT-2106"
          value={TT_2106}
          x={415}
          y={622}
          unit="°C"
          max={100}
          HH={95}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF FLUID FROM BOTTOM OF H2S SCAVENGER VESSEL TO DE-OILER VESSEL"
        />

        <Transmitter
          tag="PDT-2101"
          value={PDT_2101}
          x={125}
          y={312}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE DIFFERENCE OF H2S SCAVENGER FOR INLET AND OUTLET GAS LINE"
        />

        <Transmitter
          tag="FIC-2104"
          value={[FIC_2104]}
          x={1005}
          y={83}
          unit="SCF/S"
          max={200}
          HH={188}
          H={175}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF GAS TO DEHYDRATION FEED GAS COOLER"
        />

        




        <Pump
          tag="P-2101"
          x={871}
          y={618}
          rpm={1800}
          bladeCount={pumpData?.["P-2101"]?.bladeCount || 3}
          size={pumpData?.["P-2101"]?.size || 44}
          onClick={openPumpPanel}
        />


        <LevelTransmitterIndicator
          tag="LT_2102"
          totalLevel={50000}
          inflows={[FIC_2107]}
          outflows={[FIC_2108 + FIC_2105]}
          responseFactor={0.05}
          columnX={939}
          columnY={454}
          columnWidth={250}
          columnHeight={115}S
          textX={835}
          textY={470}
          showFlow={true}
          backgroundOpacity={0.2}
          liquidOpacity={0.8}
        />

        <LevelTransmitterIndicator
          tag="LT_2101"
          totalLevel={10000}
          inflows={[(FIC_2101 * 0.08) + FIC_2105]}
          outflows={[FIC_2106]}
          responseFactor={0.05}
          columnX={406}
          columnY={275}
          columnWidth={100}
          columnHeight={206}
          textX={520}
          textY={370}
          showFlow={true}
          backgroundOpacity={0.2}
          liquidOpacity={0.8}
        />



      
       

    </div>
  );
}


export default GasSweetening;
